import { selectUnit } from '@formatjs/intl-utils';
import moment from 'moment';
import * as React from 'react';
import { FormattedRelativeTime as IntlFormattedRelativeTime, FormattedTime } from 'react-intl';
import { FormattedMessage } from '../i18n';
import { formatDateTime, FormattedDateTime } from './FormattedDateTime';

/**
 * Renders an relative date up to 2 days and and absolute date otherwise.
 * For relative dates > 1min and < 2 days, the value is printed as "Today at 01:30"
 *
 * This replaces the the react-intl native FormattedRelativeTime
 */
export const FormattedRelativeTime: React.FC<{
  /** the time as unix timestamp (ms) */
  value: timestamp;
  className?: string;
  nowTimestamp?: timestamp;
}> = ({ value: timestamp, nowTimestamp, className }) => {
  const now = moment(nowTimestamp);
  const then = moment(timestamp);

  const { value, unit } = selectUnit(then.valueOf(), now.valueOf());

  if (unit === 'second') {
    return (
      <span className={className} title={formatDateTime(timestamp)}>
        <IntlFormattedRelativeTime value={value} unit={unit} numeric="auto" updateIntervalInSeconds={10} />
      </span>
    );
  }

  if (then.isSame(now, 'day')) {
    return (
      <span className={className} title={formatDateTime(timestamp)}>
        <FormattedMessage id="date.todayAt" /> <FormattedTime value={timestamp} />
      </span>
    );
  }

  if (then.isSame(now.subtract(1, 'day'))) {
    return (
      <span className={className} title={formatDateTime(timestamp)}>
        <FormattedMessage id="date.yesterdayAt" /> <FormattedTime value={timestamp} />
      </span>
    );
  }

  return (
    <span className={className} title={formatDateTime(timestamp)}>
      <FormattedDateTime value={timestamp} />
    </span>
  );
};
